// extracted by mini-css-extract-plugin
export var active = "_37-7";
export var container = "_37-0";
export var evenWidth = "_37-4";
export var large = "_37-5";
export var outlet = "_37-8";
export var slide = "_37-2";
export var small = "_37-6";
export var tab = "_37-3";
export var tabs = "_37-1";